import React from "react";
import fieldPropTypes from "./field-prop-types";
import { fieldValidation, isFieldsValid } from "../utils/field-validation";
import renderFields from "../screens/render-fields";
import {
  CHILDREN_COMPONENT_NAMES,
  isMessageValid
} from "../utils/list-item-wrapper-utils";

class ListItemWrapper extends React.Component {
  handleButtonClickWrapper(field, appData) {
    const childrenData = field?.childrenData || {};

    if (
      childrenData?.componentName === CHILDREN_COMPONENT_NAMES.message &&
      !isMessageValid(childrenData)
    ) {
      return;
    }

    if (fieldValidation.hasOwnProperty(field.type)) {
      fieldValidation[field.type].update(field, appData);
    }
    if (
      isFieldsValid(appData) ||
      (field.action && field.action.type === "selector")
    ) {
      appData.handleButtonClick(
        field.key,
        field.selectedData,
        field.action,
        field
      );
    } else {
      appData.screenValidation.setScreenValidity(false);
    }
  }

  prepareChildrenToRender(children, childrenType) {
    let preparedChildren = {};
    switch (childrenType) {
      case "provider":
        preparedChildren = [...this.prepareProvider(children)];
        break;
      default:
        preparedChildren = [...children];
    }
    return preparedChildren;
  }

  prepareProvider(children) {
    const {
      appData: { settings }
    } = this.props;
    return [
      ...children.filter(this.filterProviderFields),
      {
        type: "text",
        title: settings.translations.profile,
        text: children[1].title,
        name: "provider_profile",
        action: {
          value: "ConsultationBhProviderProfile",
          type: "modal_screen"
        },
        params: "TDFieldOptionBold|TDFieldOptionRight"
      },
      {
        type: "bar"
      }
    ];
  }

  filterProviderFields(field) {
    return (
      field.type !== "webImage" || (field.type === "webImage" && field.url)
    );
  }

  render() {
    const { field, lastOfKind, appData, components, children } = this.props;

    return field.renderFields ? (
      <components.ListItem
        onClick={() => this.handleButtonClickWrapper(field, appData)}
        childType={field.childrenType}
        lastOfKind={lastOfKind}
      >
        {renderFields(
          this.prepareChildrenToRender(
            field.childrenData.childrenList,
            field.childrenType
          ),
          appData,
          components
        )}
      </components.ListItem>
    ) : (
      <components.ListItem
        onClick={() => this.handleButtonClickWrapper(field, appData)}
        childType={field.childrenType}
        lastOfKind={lastOfKind}
      >
        {children}
      </components.ListItem>
    );
  }
}

ListItemWrapper.propTypes = fieldPropTypes;

export default ListItemWrapper;
